import React, { FC, Fragment, useEffect, useState } from 'react'
import { Paper, Tabs, makeStyles, Tab, Hidden, BottomNavigation, BottomNavigationAction, Container } from '@material-ui/core';
import LocalParking from '@material-ui/icons/LocalParking';
import Computer from '@material-ui/icons/Computer';
import AllInbox from '@material-ui/icons/AllInbox';
import Search from '@material-ui/icons/Search';
import Build from '@material-ui/icons/Build';
import { useHistory, useLocation } from 'react-router-dom';
import { Redirect, Route, Switch } from 'react-router-dom';
import LocationOverview from './LocationOverview';
import DeviceOverview from './DeviceOverview';
import DeviceLog from './DeviceLog';
import DeviceManage from './DeviceManage';
import LocationSearch from './LocationSearch';
import Checkout from './Checkout';
import { RouteLocationProps, CheckoutLocationProps } from '../../routes/mobilbase';

const useStyles =  makeStyles({
  root: {
    flexGrow: 1,
    //maxWidth: 500,
  },
  stickToBottom: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    // marginLeft: "-24px",
  },

  button: {
    minWidth: "unset",
  }
});

// interface Props {
//   matchUrl: string
// }

interface Nav {
  location: boolean;
  device: boolean;
  search: boolean;
  log: boolean;
  manage: boolean;
}

const InternalNavigation: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const routeLocation = useLocation<RouteLocationProps>();
  const {page} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
  const [currentPage, setCurrentPage] = useState(-1);
  const [currentNav, setCurrentNav] = useState<Nav>({location: true, device: false, search: false, log: false, manage: false});

  useEffect(() => {
    if (currentPage === -1 || currentPage !== page) {
      const {page} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
      setCurrentPage(page);
      setCurrentNav(getNav(page));
    }
  }, [currentPage, page, routeLocation.state]);

  const getNav = (page: number) => {
    let nav: Nav = {location: true, device: false, search: false, log: false, manage: false};
    switch (page) {
      case 0: //LOCATION
        nav = { location: true, device: false, search: false, log: false, manage: false }  
        break;
      case 1: //DEVICE
        nav = { location: true, device: true, search: true, log: false, manage: false }  
        break;
      case 2 || 5: //SEARCH
        nav = { location: true, device: true, search: true, log: false, manage: false }  
        break;       
      case 3: //LOG
        nav = { location: true, device: true, search: true, log: true, manage: true }  
        break;
      case 4: //MANGE
        nav = { location: true, device: true, search: true, log: true, manage: true }  
        break;  
      default:
        break;
    }
    return nav;
  }

  const changePage = (historyState: RouteLocationProps) => {
    setCurrentPage(historyState.page);
    setCurrentNav(getNav(historyState.page))
    
    switch (historyState.page) {
      case 0: //LOCATION
        history.push('/mobilbase/plads', historyState); 
        break;
      case 1: //DEVICE
        history.push('/mobilbase/plads/automat', historyState); 
        break;
      case 2: //SEARCH
        history.push('/mobilbase/plads/search', historyState); 
        break;       
      case 3: //LOG
        history.push('/mobilbase/plads/automat/log', historyState); 
        break;
      case 4: //MANGE
        history.push('/mobilbase/plads/automat/administrer', historyState);
        break;   
      default:
        break;
    }
  }

  const changePageCheckout = (historyState: CheckoutLocationProps) => {
    setCurrentPage(2);
    setCurrentNav({ location: true, device: true, search: true, log: false, manage: false })
    history.push('/mobilbase/plads/automat/checkout', historyState);
  }

  const handleChange = (_: React.ChangeEvent<{}> | null, newValue: number) => {
    const {selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
    changePage(new RouteLocationProps(newValue, selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName));
  };

  return (
    <Fragment>
      <Hidden smDown>
        <Container>
        <Paper square className={classes.root}>
          <Tabs
            value={currentPage}
            onChange={handleChange}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            aria-label="icon label tabs example"
          >
            <Tab disabled={!currentNav.location} icon={<LocalParking />} label="Pladsoversigt" />
            <Tab disabled={!currentNav.device} icon={<Computer />} label="Automatoversigt" />
            <Tab disabled={!currentNav.search} icon={<Search />} label="Søg" />
            <Tab disabled={!currentNav.log} icon={<AllInbox />} label="Hændelseslog" />
            <Tab disabled={!currentNav.manage} icon={<Build />} label="Administrer" />
          </Tabs>
        </Paper>
        </Container>
      </Hidden>
        <Switch>
          <Route exact path={`/mobilbase`}>
            <Redirect to={`/mobilbase/plads`}/>
          </Route>
            <Route exact path={`/mobilbase/plads`}>
              <LocationOverview navFunc={changePage}/>
            </Route>
            <Route exact path={`/mobilbase/plads/search`}>
              <LocationSearch navFunc={changePageCheckout}/>
            </Route>
            <Route exact path={`/mobilbase/plads/automat`}>
              <DeviceOverview navFunc={changePage}/>
            </Route>
            <Route exact path={`/mobilbase/plads/automat/checkout`}>
              <Checkout />
            </Route>
            <Route path={`/mobilbase/plads/automat/log`}>
              <DeviceLog />
            </Route>
            <Route path={`/mobilbase/plads/automat/administrer`}>
              <DeviceManage />
            </Route>
            <Route> <div>Siden bliv ikke fundet</div></Route>
        </Switch>
   
      <Hidden mdUp>
        <BottomNavigation
          value={currentPage}
          onChange={handleChange}
          showLabels
          className={classes.stickToBottom}
        >
          {currentNav.location &&
            <BottomNavigationAction disabled={!currentNav.location} className={classes.button} label="Pladser" icon={<LocalParking />} />
          }
          {currentNav.device &&
            <BottomNavigationAction disabled={!currentNav.device} className={classes.button} label="Automater" icon={<Computer />} />
          }            
          {currentNav.search &&
            <BottomNavigationAction disabled={!currentNav.search} className={classes.button} label="Søg" icon={<Search />} />
          }
          {currentNav.log &&
            <BottomNavigationAction disabled={!currentNav.log} className={classes.button} label="Log" icon={<AllInbox />} />
          }
          {currentNav.manage &&
            <BottomNavigationAction disabled={!currentNav.manage} className={classes.button} label="Administrer" icon={<Build />} />
          }
        </BottomNavigation>
      </Hidden>
    </Fragment>
      
  )
}

export default InternalNavigation;